// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__jqZCv","label":"Completed_label__tCLkR"};